"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Foquz = exports.isFoquzUiTestEnv = exports.isFoquzUnavailableHost = exports.isFoquzAvailable = exports.FOQUZ_UNAVAILABLE_HOSTS = exports.FOQUZ_UI_TEST_ENV_COOKIE = exports.FOQUZ_AVAILABILITY_POLL_MS = void 0;
const event_bus_1 = require("@vtblife/event-bus");
const availability_1 = require("./availability");
var availability_2 = require("./availability");
Object.defineProperty(exports, "FOQUZ_AVAILABILITY_POLL_MS", { enumerable: true, get: function () { return availability_2.FOQUZ_AVAILABILITY_POLL_MS; } });
Object.defineProperty(exports, "FOQUZ_UI_TEST_ENV_COOKIE", { enumerable: true, get: function () { return availability_2.FOQUZ_UI_TEST_ENV_COOKIE; } });
Object.defineProperty(exports, "FOQUZ_UNAVAILABLE_HOSTS", { enumerable: true, get: function () { return availability_2.FOQUZ_UNAVAILABLE_HOSTS; } });
Object.defineProperty(exports, "isFoquzAvailable", { enumerable: true, get: function () { return availability_2.isFoquzAvailable; } });
Object.defineProperty(exports, "isFoquzUnavailableHost", { enumerable: true, get: function () { return availability_2.isFoquzUnavailableHost; } });
Object.defineProperty(exports, "isFoquzUiTestEnv", { enumerable: true, get: function () { return availability_2.isFoquzUiTestEnv; } });
const FOQUZ_AUTH_EVENT = 'app:contextChanged';
const FOQUZ_TRIGGER_WIDGET_EVENT = 'foquz:triggerWidget';
function buildAuthPayload(context) {
    var _a, _b;
    const user = (_a = context === null || context === void 0 ? void 0 : context.authInfo) === null || _a === void 0 ? void 0 : _a.user;
    const isAuthenticated = (_b = context === null || context === void 0 ? void 0 : context.authInfo) === null || _b === void 0 ? void 0 : _b.isAuthenticated;
    return {
        client_id: (user === null || user === void 0 ? void 0 : user.userId) ? user.userId : null,
        client_role: (user === null || user === void 0 ? void 0 : user.currentRole) ? user.currentRole : null,
        client_role_type: (user === null || user === void 0 ? void 0 : user.currentRoleType) ? user.currentRoleType : null,
        is_authenticated: typeof isAuthenticated === 'boolean' ? isAuthenticated : null,
    };
}
function isSameAuthPayload(a, b) {
    return (a.client_id === b.client_id &&
        a.client_role === b.client_role &&
        a.client_role_type === b.client_role_type &&
        a.is_authenticated === b.is_authenticated);
}
function tryTriggerWidget(eventName, payload, onError = () => undefined) {
    if (typeof window === 'undefined')
        return false;
    const widget = window.FQZWidget;
    if (typeof (widget === null || widget === void 0 ? void 0 : widget.triggerEvent) !== 'function')
        return false;
    try {
        widget.triggerEvent(eventName, payload);
    }
    catch (error) {
        try {
            onError(error, { eventName, phase: 'trigger' });
        }
        catch (_a) {
        }
        return false;
    }
    return true;
}
class Foquz {
    static getInstance() {
        if (!Foquz.instance) {
            Foquz.instance = new Foquz();
        }
        return Foquz.instance;
    }
    getAuthContext() {
        return this.authContext;
    }
    configureBridge(options) {
        if (typeof window === 'undefined') {
            return { dispose: () => undefined };
        }
        if (this.activeBridge) {
            return this.activeBridge;
        }
        const onError = options === null || options === void 0 ? void 0 : options.onError;
        const eventBus = event_bus_1.EventBus.getInstance();
        let lastSentPayload;
        let pollTimerId;
        let pollAttempts = 0;
        let disposed = false;
        const pendingTriggers = [];
        const stopPolling = () => {
            if (pollTimerId !== undefined) {
                window.clearInterval(pollTimerId);
                pollTimerId = undefined;
            }
            pollAttempts = 0;
        };
        const trySendAuth = (payload) => {
            if (!tryTriggerWidget(FOQUZ_AUTH_EVENT, payload, onError))
                return false;
            lastSentPayload = payload;
            return true;
        };
        const tryFlushTriggers = () => {
            if ((0, availability_1.isFoquzUiTestEnv)()) {
                pendingTriggers.length = 0;
                return true;
            }
            if (!this.authContext)
                return pendingTriggers.length === 0;
            while (pendingTriggers.length > 0) {
                const next = pendingTriggers[0];
                if (this.sendEvent(next.eventId, next.params, { onError })) {
                    pendingTriggers.shift();
                }
                else {
                    return false;
                }
            }
            return true;
        };
        const tryProcessPending = () => {
            if ((0, availability_1.isFoquzUiTestEnv)()) {
                pendingTriggers.length = 0;
                return true;
            }
            if (this.authContext) {
                const needAuthSend = !lastSentPayload || !isSameAuthPayload(lastSentPayload, this.authContext);
                if (needAuthSend && !trySendAuth(this.authContext)) {
                    return false;
                }
            }
            else if (pendingTriggers.length > 0) {
                return false;
            }
            return tryFlushTriggers();
        };
        const ensurePolling = () => {
            if (disposed || pollTimerId !== undefined)
                return;
            pollAttempts = 0;
            pollTimerId = window.setInterval(() => {
                pollAttempts += 1;
                if (tryProcessPending() || pollAttempts >= availability_1.FOQUZ_AVAILABILITY_POLL_MAX_ATTEMPTS) {
                    if (pollAttempts >= availability_1.FOQUZ_AVAILABILITY_POLL_MAX_ATTEMPTS) {
                        pendingTriggers.length = 0;
                    }
                    stopPolling();
                }
            }, availability_1.FOQUZ_AVAILABILITY_POLL_MS);
        };
        const authSubscription = eventBus.subscribe('app:contextChanged', (event) => {
            if (disposed)
                return;
            const payload = buildAuthPayload(event.data);
            const baseline = lastSentPayload !== null && lastSentPayload !== void 0 ? lastSentPayload : this.authContext;
            if (baseline && isSameAuthPayload(baseline, payload) && pendingTriggers.length === 0)
                return;
            this.authContext = payload;
            if (!tryProcessPending()) {
                ensurePolling();
            }
            else {
                stopPolling();
            }
        }, { eventCategory: 'behavior' });
        const triggerSubscription = eventBus.subscribe(FOQUZ_TRIGGER_WIDGET_EVENT, (event) => {
            var _a;
            if (disposed)
                return;
            const eventId = (_a = event.data) === null || _a === void 0 ? void 0 : _a.eventId;
            if (!eventId)
                return;
            if ((0, availability_1.isFoquzUiTestEnv)())
                return;
            pendingTriggers.push({ eventId, params: event.data.params });
            if (!tryProcessPending()) {
                ensurePolling();
            }
            else {
                stopPolling();
            }
        }, { eventCategory: 'simple' });
        const handle = {
            dispose: () => {
                if (disposed)
                    return;
                disposed = true;
                stopPolling();
                pendingTriggers.length = 0;
                authSubscription.unsubscribe();
                triggerSubscription.unsubscribe();
                lastSentPayload = undefined;
                this.authContext = undefined;
                if (this.activeBridge === handle) {
                    this.activeBridge = undefined;
                }
            },
        };
        this.activeBridge = handle;
        return handle;
    }
    sendEvent(eventName, payload, options) {
        const eventPayload = (options === null || options === void 0 ? void 0 : options.mergeAuth) !== false && this.authContext ? Object.assign(Object.assign({}, this.authContext), payload) : payload;
        return tryTriggerWidget(eventName, eventPayload, options === null || options === void 0 ? void 0 : options.onError);
    }
}
exports.Foquz = Foquz;
//# sourceMappingURL=foquz.js.map